import React, { useState, useMemo, Suspense } from 'react';
import './Photos.css';

// ✅ Lazy load EnlargedImage component
const EnlargedImage = React.lazy(() => import('./EnlargedImage'));

// ✅ Memoized image item
const PhotoItem = React.memo(({ src, alt, onClick }) => {
  return (
    <div className="photo-item">
      <img
        src={src}
        alt={alt}
        className="photo-img"
        loading="lazy"
        onClick={onClick}
      />
    </div>
  );
});

function PicnicPage() {
  const totalImages = 14;
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleClose = () => setEnlargedImage(null);
  const handleImageClick = (image) => setEnlargedImage(image);

  const loadImage = (index) => `/images/school_picnic/${index + 1}.jpg`;

  const images = useMemo(() => {
    return Array.from({ length: totalImages }, (_, index) => ({
      src: loadImage(index),
      alt: `Picnic ${index + 1}`,
    }));
  }, [totalImages]);

  return (
    <div className="photos-container">
      <h2 className="photos-heading">SCHOOL PICNIC</h2>

      {enlargedImage && (
        <Suspense fallback={<div className="loading-overlay">Loading...</div>}>
          <EnlargedImage image={enlargedImage} onClose={handleClose} />
        </Suspense>
      )}

      <div className="photos-grid">
        {images.map((image, index) => (
          <PhotoItem
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => handleImageClick(image.src)}
          />
        ))}
      </div>
    </div>
  );
}

export default PicnicPage;
